import { put, takeLatest } from "redux-saga/effects";

import {
  requestbusinesscenter,
  requestCreateBusinessCenter,
  requestFloorBookingDetails,
  requestFloorSeatDetails,
  requestFloorSuiteDetails,
  requestSuitesByLocation,
  requestSuitesByFloor,
  requestLocationSuiteAvailability,
  requestUpdateWorkstationStatus,
  requestUpdateBusinessCenterStatus,
  requestAllFloorBookingDetails
} from "../../../services/businessCenter";
import {
  fetchbusinessCenterListFaliure,
  fetchbusinessCenterListRequest,
  fetchbusinessCenterListSuccess,
  createBusinessCenterRequest,
  createBusinessCenterSuccess,
  createBusinessCenterFailure,
  fetchFloorBookingDetailsListRequest,
  fetchFloorBookingDetailsListSuccess,
  fetchFloorBookingDetailsListFaliure,
  fetchFloorSeatDetailsListRequest,
  fetchFloorSeatDetailsListSuccess,
  fetchFloorSeatDetailsListFaliure,
  fetchFloorSuiteDetailsListRequest,
  fetchFloorSuiteDetailsListSuccess,
  fetchFloorSuiteDetailsListFaliure,
  fetchAllFloorBookingDetailsListRequest,
  fetchAllFloorBookingDetailsListSuccess,
  fetchAllFloorBookingDetailsListFaliure,
  
  updateWorkstationStatusRequest,
  updateWorkstationStatusSuccess,
  updateWorkstationStatusFailure,
  
  updateBusinessCenterStatusRequest,
  updateBusinessCenterStatusSuccess,
  updateBusinessCenterStatusFailure,
  fetchLocationSuiteDetailsListRequest,
  fetchSuitesByFloorListRequest,
  fetchLocationSuiteAvailabilityRequest,
  fetchLocationSuiteAvailabilitySuccess,
  fetchLocationSuiteAvailabilityFailure,
} from "../../reducers/businessCenter";

export function* watchbusinessCenterSaga() {
  yield takeLatest(fetchbusinessCenterListRequest, fetchbusinessCenter);
  yield takeLatest(createBusinessCenterRequest, createBusinessCenter);
  yield takeLatest(
    fetchFloorBookingDetailsListRequest,
    fetchFloorBookingDetails
  );
  yield takeLatest(
    fetchFloorSeatDetailsListRequest,
    fetchFloorSeatDetails
  );
  yield takeLatest(
    fetchFloorSuiteDetailsListRequest,
    fetchFloorSuiteDetails
  );
  yield takeLatest(
    fetchLocationSuiteDetailsListRequest,
    fetchLocationSuiteDetails
  );
  yield takeLatest(
    fetchSuitesByFloorListRequest,
    fetchSuitesByFloor
  );
  yield takeLatest(
    fetchLocationSuiteAvailabilityRequest,
    fetchLocationSuiteAvailability
  );
  yield takeLatest(
    fetchAllFloorBookingDetailsListRequest,
    fetchAllFloorBookingDetails
  );
  yield takeLatest(updateWorkstationStatusRequest, updateWorkstationStatus);
  yield takeLatest(updateBusinessCenterStatusRequest, updateBusinessCenterStatus);
  
}

/**
 *
 * @param {*} param0
 */
function* fetchbusinessCenter({ payload }) {
  try {
    const response = yield requestbusinesscenter(payload);
    yield put(fetchbusinessCenterListSuccess(response));
  } catch (error) {
    yield put(
      fetchbusinessCenterListFaliure("Failed to get list of Business Center")
    );
  }
}

function* createBusinessCenter({ payload }) {
  try {
    //service add
    const response = yield requestCreateBusinessCenter(payload);
    yield put(createBusinessCenterSuccess(response.data[0]));
  } catch (error) {
    yield put(createBusinessCenterFailure("Failed to create Business Center"));
  }
}

function* fetchFloorBookingDetails({ payload }) {
  try {
    const response = yield requestFloorBookingDetails(payload);
    yield put(fetchFloorBookingDetailsListSuccess(response));
  } catch (error) {
    yield put(
      fetchFloorBookingDetailsListFaliure("Failed to get list of Floor Details")
    );
  }
}
function* fetchFloorSeatDetails({ payload }) {
  try {
    const response = yield requestFloorSeatDetails(payload);
    yield put(fetchFloorSeatDetailsListSuccess(response));
  } catch (error) {
    yield put(
      fetchFloorSeatDetailsListFaliure("Failed to get list of Floor Details")
    );
  }
}

function* fetchFloorSuiteDetails({ payload }) {
  try {
    const response = yield requestFloorSuiteDetails(payload);
    yield put(fetchFloorSuiteDetailsListSuccess(response));
  } catch (error) {
    yield put(
      fetchFloorSuiteDetailsListFaliure("Failed to get list of Floor Suite Details")
    );
  }
}

function* fetchLocationSuiteDetails({ payload }) {
  try {
    const response = yield requestSuitesByLocation(payload);
    yield put(fetchFloorSuiteDetailsListSuccess(response));
  } catch (error) {
    yield put(
      fetchFloorSuiteDetailsListFaliure("Failed to get list of Suites by Location")
    );
  }
}

function* fetchSuitesByFloor({ payload }) {
  try {
    const response = yield requestSuitesByFloor(payload);
    yield put(fetchFloorSuiteDetailsListSuccess(response));
  } catch (error) {
    yield put(
      fetchFloorSuiteDetailsListFaliure("Failed to get list of Suites by Floor")
    );
  }
}

function* fetchLocationSuiteAvailability({ payload }) {
  try {
    const response = yield requestLocationSuiteAvailability(payload);
    yield put(fetchLocationSuiteAvailabilitySuccess(response));
  } catch (error) {
    yield put(
      fetchLocationSuiteAvailabilityFailure(
        "Failed to get location suite availability"
      )
    );
  }
}

function* fetchAllFloorBookingDetails({ payload }) {
  try {
    const response = yield requestAllFloorBookingDetails(payload);
    yield put(fetchAllFloorBookingDetailsListSuccess(response));
  } catch (error) {
    yield put(
      fetchAllFloorBookingDetailsListFaliure("Failed to get list of Floor Details")
    );
  }
}

function* updateWorkstationStatus({ payload }) {
  try {
    //service add
    const response = yield requestUpdateWorkstationStatus(payload);
    yield put(updateWorkstationStatusSuccess(response.data));
  } catch (error) {
    yield put(
      updateWorkstationStatusFailure(
        "Failed to update status of workstation of the business center"
      )
    );
  }
}


/**
 *
 * @param {*} param0
 */
 function* updateBusinessCenterStatus({ payload }) {
  try {
    const response = yield requestUpdateBusinessCenterStatus(payload);
    yield put(updateBusinessCenterStatusSuccess(response.data));
  } catch (error) {
    yield put(
      updateBusinessCenterStatusFailure("Failed to update status of Business Center")
    );
  }
}
